import React, { useState, useEffect, useRef } from 'react';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import moment from 'moment';
import PopUp from '../../common/components/PopUp/PopUp';
import Modal from '../../common/components/Modal/modal';
import GlobalMonthRangePicker from '../../common/components/GlobalMonthPicker/GlobalMonthPicker';
import { editTargetMonth } from '../../common/constants/api';
import Style from './TargetMonth.module.css';

export const currentYear = parseInt(moment().format('YYYY'));
export const currentMonth = moment().format('M');

const AssignTargetMonth = props => {
  const { modal_det } = Style;
  const [showModal, setShowModal] = useState(true);
  const [popUpType, setpopUpType] = useState('loading');
  const [popUpText, setpopUpText] = useState('Loading...');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (props.leadId) {
      setShowModal(true);
    }
  }, [props.ReassignTargetMonth]);

  const [validRange, setValidRange] = useState({
    min: { year: 2000, month: 1, date: 28 },
    max: {
      year: currentYear + 10,
      month:
        moment()
          .subtract(1, 'months')
          .month() + 1,
      date: 28
    }
  });
  const [rangeValue, setRangeValue] = useState({
    year: parseInt(moment().format('YYYY')),
    month: parseInt(moment()?.format('MM')),
    date: 28
  });
  const handleSubmittion = () => {
    let targetMonthUpdate =
      rangeValue.year + '-' + rangeValue.month + '-' + '28';
    setShowModal(false);
    setSubmitting(true);
    setpopUpText('Updating target month Please wait...');
    setpopUpType('loading');
    setLoading(true);
    editTargetMonth(props?.leadId, targetMonthUpdate)
      .then(res => {
        if (res.error) throw new Error(res);
        setLoading(false);
        props.setShowReassignMonth(false);
        props?.showMonth(targetMonthUpdate);
      })
      .catch(error => {
        setShowModal(false);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (!showModal) {
      props.setShowReassignMonth(false);
    }
  }, [showModal]);

  const getTargetMonth = () => {
    if (props.settargetMonth !== 'null') {
      return moment(props?.settargetMonth).format('MMM-YYYY');
    }
    return <span> NA </span>;
  };
  return (
    <React.Fragment>
      <Modal show={showModal} setShow={setShowModal} classStyle={modal_det}>
        <div className="w-full block h-auto bg-white mx-auto">
          <p className="text-base text-grey-995 text-left font-roboto font-normal py-1 ">
            {props.name} - {props?.leadId}
          </p>
          <hr className="text-grey-999 my-2" />
          <div className="w-full bg-grey-1004 block py-1 px-3 mt-4">
            <div className="md:flex flex-wrap">
              <p className="font-roboto  text-black-500 py-2 text-base font-norml text-left">
                Current Target Month
              </p>

              <p className="font-roboto  text-green-600 md:py-2 py-2 text-base font-norml  md:text-right text-left md:ml-auto md:px-6">
                {getTargetMonth()}
              </p>
            </div>
            <hr className="text-grey-999 my-2" />
            <div className=" h-64 ">
              <p className="font-roboto text-black-500 pt-4 text-base font-norml text-left">
                Edit Target Month
              </p>
              <div>
                <GlobalMonthRangePicker
                  singlePicker
                  rangeValue={{ ...rangeValue }}
                  setRangeValue={setRangeValue}
                  validRange={{ ...validRange }} //{min: 2013}//[2013, 2015, 2016]//5// {max: 2015}
                />
              </div>
            </div>
            <div className="w-full flex pb-4">
              <button
                className="w-24 px-3 py-3 bg-white text-green-600 font-roboto font-normal rounded ml-auto  "
                onClick={() =>
                  typeof props?.setShowReassignMonth == 'function'
                    ? props.setShowReassignMonth(false)
                    : null
                }
              >
                Cancel
              </button>
              <button
                type="button"
                className={
                  'w-24 px-3 py-3 bg-green-600 text-white font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded'
                }
                onClick={handleSubmittion}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default withErrorHandler(AssignTargetMonth);
